import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

/**
 * Tiny live badge that displays the current Central Time (America/Chicago)
 * so anyone reading a financial report knows the day boundaries the figures
 * are using — staffers in other timezones, accountants, etc.
 */
const CtBadge = ({ compact = false, testId = 'ct-badge' }) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        // Tick every 30s — keeps clock fresh without burning CPU
        const id = setInterval(() => setNow(new Date()), 30_000);
        return () => clearInterval(id);
    }, []);

    const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
    const dateFmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        weekday: 'short',
        month: 'short',
        day: 'numeric',
    });

    const time = fmt.format(now);
    const date = dateFmt.format(now);

    return (
        <span
            className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#FFD700]/10 border border-[#FFD700]/30 text-[#FFD700] text-[11px] font-mono"
            title="All figures use America/Chicago day boundaries"
            data-testid={testId}
        >
            <Clock className="w-3 h-3" />
            {compact ? `${time} CT` : `${date} · ${time} CT`}
        </span>
    );
};

export default CtBadge;
